"use client";

import React from "react";
import { Play, Headphones, Radio, Mic, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PodcastSpotlight() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  const platforms = [{
    name: "Apple Podcasts",
    icon: <Mic className="w-5 h-5" />,
    url: "#"
  }, {
    name: "Spotify",
    icon: <Headphones className="w-5 h-5" />,
    url: "#"
  }, {
    name: "Stitcher",
    icon: <Radio className="w-5 h-5" />,
    url: "#"
  }, {
    name: "Google Podcasts",
    icon: <Play className="w-5 h-5" />,
    url: "#"
  }];
  return;
}